import { Spinner } from "react-bootstrap";

interface LoadingIconWithTextProps {
  loadingText?: string | null;
}

const LoadingIconWithText = ({ loadingText = "กำลังโหลด..." }: LoadingIconWithTextProps) => {
  return (
    <>
      {loadingText != "" ? (
        <div className="loading-icon-with-text">
          <Spinner color="primary" size="sm"></Spinner>
          {loadingText && (<i>{loadingText}</i>)}
        </div>
      ) : (<Spinner color="primary" size="sm"></Spinner>)}
    </>
  );

}

export default LoadingIconWithText;